import { Box, Grid, makeStyles, styled } from '@material-ui/core';

export const LoadContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  gridGap: 18,
  width: '100%',
  height: '100%'
});

export const LoadContent = styled(Box)({
  width: 320,
  height: 320,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
});

export const Content = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4),
  flex: 1,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  scrollBehavior: 'smooth'
}));

export const TableContainer = styled(Box)({
  flex: 1,
  width: '100%',
  height: '100%',
  // overflow: 'auto',
  flexDirection: 'column',
  paddingBottom: 16
  // scrollBehavior: 'smooth'
});

export const LoadingContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing('14px', 3),
  display: 'flex',
  alignItems: 'center',
  borderRadius: 26,
  gap: 12,
  background: '#fff',
  boxShadow: '0px 2px 12px rgba(0, 0, 0, 0.15)'
}));

export const FeedbackContainer = styled(Grid)({
  width: 'fit-content',
  position: 'absolute',
  bottom: 12,
  left: 12
});

export const ScrollToTopContainer = styled(Grid)({
  width: 'fit-content',
  position: 'absolute',
  bottom: 18,
  right: 30,

  borderRadius: 8
});

export const useStyles = makeStyles({
  dialogPaper: {
    width: '95%',
    height: '95%',
    maxHeight: '95% !important',
    maxWidth: '95% !important',
    borderRadius: 24
  }
});
